import { SALE_ORDER_STATUS } from "../../../data/enums";
import { ColorTheme } from "../../../shared/components/Status";

export const getStatusColorTheme = (status: string): ColorTheme => {
    switch (status) {
        case SALE_ORDER_STATUS.OPEN:
            return "INFO";
        case SALE_ORDER_STATUS.LOGISTIC_REVIEWED:
            return "PENDING";
        case SALE_ORDER_STATUS.MATERIAL_REQUESTED_AND_MANUFACTURING:
            return "WARNING";
        case SALE_ORDER_STATUS.IMPORTING_AND_EXPORTING:
            return "WAREHOUSE";
        case SALE_ORDER_STATUS.COMPLETED:
            return "SUCCESS";
        case SALE_ORDER_STATUS.CANCELLED:
            return "FAIL";
        default:
            return "INFO";
    }
};
